import './TransferList.b9f269581c0ff6a7f8613cd37fbe9f34.css';
export default {"transferList":"_transferList_tv4iy_1","controls":"_controls_tv4iy_1"};